var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAction2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.0169,
    cy: 69.9837,
    r: 69.9837,
    fill: "#FFF9E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_2076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.306286 19.75C0.306286 19.75 -1.62429 103.827 4.17766 157.056H119.359C119.359 157.056 100.002 56.6557 100.962 19.75H0.306286Z",
    fill: "#107393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5449 43.2338V69.5162H63.9953L61.9421 38.7598L13.5449 43.2338Z",
    fill: "#A9CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9607 93.6328C82.5143 93.6328 91.8804 85.2043 91.8804 74.8071C91.8804 64.41 82.5143 55.9814 70.9607 55.9814C59.4071 55.9814 50.041 64.41 50.041 74.8071C50.041 85.2043 59.4071 93.6328 70.9607 93.6328Z",
    fill: "#D9E0A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0363 61.7016L59.7142 86.2169C59.7142 86.2169 50.2656 77.3607 56.7213 67.3503C63.177 57.3399 75.0363 61.7016 75.0363 61.7016Z",
    fill: "#107393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3162 63.0605L63.9941 88.4032C63.9941 88.4032 75.0362 95.1858 83.4021 84.1028C91.7679 73.0199 79.3162 63.0605 79.3162 63.0605Z",
    fill: "#107393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9949 64.3574V69.4648L57.7129 69.2298C58.3131 67.988 59.1925 66.902 60.2823 66.0567C61.3722 65.2114 62.6429 64.6298 63.9949 64.3574V64.3574Z",
    fill: "#A9CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1582 82.5088V88.4027L44.2803 85.4608V82.5088H15.1582Z",
    fill: "#A9CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1582 96.248V99.7415H76.2727L15.1582 96.248Z",
    fill: "#A9CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1582 107.321V112.653L101.094 109.987V103.021L15.1582 107.321Z",
    fill: "#A9CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6973 119.425V124.961L105.804 122.193V116.963L12.6973 119.425Z",
    fill: "#A9CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5449 129.681V133.981L105.804 131.836V128.036L13.5449 129.681Z",
    fill: "#A9CBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0176 136.851V149.568H112.985L108.878 133.98L66.0176 136.851Z",
    fill: "#A9CBDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_2076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.359,
    height: 137.306,
    fill: "white",
    transform: "translate(0 19.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction2);
export default __webpack_public_path__ + "static/media/action2.e88a8fb01b884b461021a2e53557a71b.svg";
export { ForwardRef as ReactComponent };